<div
  class="annotation-section"
  [ngClass]="{
    'with-class-selector': (isClassSelectorOpen$ | async),
  }"
>
  <h3-annotation-list h3ScrollEnabler></h3-annotation-list>
  <h3-annotation-edit-pane></h3-annotation-edit-pane>
</div>
